<template>
  <div
    class="grid w-full grid-cols-[1fr_minmax(0px,1740px)_1fr] gap-x-5 gap-y-0 desktop:gap-x-[3rem] desktopLarge:gap-x-[5.625rem]"
  >
    <slot />
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped></style>
